const sv = {
    nav: {
      home: "Hem",
      browse: "Utforska bröllop",
      dashboard: "Instrumentpanel",
      messages: "Meddelanden",
      profile: "Profil",
      login: "Logga in",
      register: "Registrera",
      logout: "Logga ut",
      admin: "Admin",
      faq: "FAQ",
      about: "Om oss",
      contact: "Kontakt",
      pricing: "Priser",
      howItWorks: "Hur det fungerar",
    },
    auth: {
      login: {
        title: "Välkommen tillbaka",
        email: "E-post",
        password: "Lösenord",
        button: "Logga in",
        noAccount: "Har du inget konto?",
        register: "Registrera dig nu",
      },
      register: {
        title: "Skapa konto",
        name: "Fullständigt namn",
        email: "E-post",
        password: "Lösenord",
        role: "Jag vill...",
        roleHost: "Arrangera ett bröllop",
        roleGuest: "Delta i bröllop",
        terms: "Jag accepterar villkoren och sekretesspolicyn",
        button: "Registrera",
        hasAccount: "Redan registrerad?",
        login: "Logga in nu",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Laddar...",
      error: "Ett fel uppstod",
      success: "Lyckades",
      save: "Spara",
      cancel: "Avbryt",
      delete: "Ta bort",
      edit: "Redigera",
      back: "Tillbaka",
      next: "Nästa",
      language: "Språk",
      currency: "Valuta",
      search: "Sök",
      filter: "Filtrera",
      all: "Alla",
      none: "Ingen",
      yes: "Ja",
      no: "Nej",
    },
    footer: {
      about: "Om oss",
      privacy: "Integritet",
      terms: "Villkor",
      contact: "Kontakt",
      copyright: "© 2024 WEDVAYA. Alla rättigheter förbehållna.",
    },
  };

export default sv;
